module.exports = __webpack_public_path__ + "omniv2/img/icon-engine.80f50e6d.svg";